<template>
    <modal v-model="showModal" @hidden="onHide" size="small">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Cancel Booking</h2>
                <div class="mt--2 heading-small">Cancel your booking reservation</div>
            </div>
        </template>
        <form @submit.prevent="save" class="row">
            <div class="col-lg-12">
                <form-input
                    type="textarea"
                    placeholder="Cancellation message"
                    label="Cancellation message"
                    v-model="form.cancellation_message"
                    ref="cancellation_message"
                ></form-input>
            </div>
            <div class="col-lg-12">
                <button v-if="!isRequesting" type="submit" class="btn btn-warning long float-right">
                    <i class="fa fa-save mr-1"></i> Submit
                </button>
                <button v-else disabled class="disabled btn btn-warning long float-right">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                </button>
            </div>
        </form>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import { route, put } from '@utils/network';
import Form from '@models/components/Form';

export default {
    name: 'ChangePasswordForm',

    data: () => ({
        isRequesting: false,
        showModal: false,
        clearModal: true,
        form: new Form({
            cancellation_message: "",
        })
    }),

    methods: {
        clearFields(includeErrors = true) {
            this.form.reset();

            if (includeErrors) {
                this.$refs.cancellation_message.clearError();
            }
        },

        show() {
            this.showModal = true;
        },

        onHide() {
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },

        async save() {
            this.clearModal = this.showModal = false;
            if (!(await this.confirm("Are you sure you want to cancel your booking?", "")).value) {
                this.showModal = true;
                return;
            }
            this.isRequesting = this.clearModal = this.showModal = true;
            put(route("bookings/:id/cancel", { id: this.bookingId }), { data: this.form.getData() })
                .then(response => this.cancelled(response))
                .catch(error => this.cancellationFailed(error))
                .finally(() => this.isRequesting = false);
        },

        cancelled(response) {
            this.$emit("cancelled", response);
            this.promptSuccess(response.data.message)
                .then(() => this.reload());
        },

        cancellationFailed(error) {
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [ mixins ],

    props: {
        bookingId: Number,
    },

    mounted() {
        this.form.save();
    }
}
</script>